<template>
  <div>
     <!-- modal qr -->
    <b-modal
      no-close-on-backdrop
      centered
      v-model="showQrModal"
      title="QR de Vehículo"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="light"
      footer-bg-variant="light"
    >
      <b-container fluid>
        <center>
        <p>{{qrValue}}</p>
        <div ref="printMe" style="margin-top: 3px; width: 206px; height: 206px;">
        <div style="height: 3px;"></div>
        <qrcode-vue
          :value=qrValue
          level='H'
          :size=width >
          </qrcode-vue>
          </div>
          </center>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="md"
            class="float-right"
            @click="goListVehicles"
          >
             <p id="ready">
            Listo</p>
          </b-button>
           <b-button
            :disabled = loadingSave
            variant="dark"
            size="md"
            class="float-left"
            @click="saveImage"
          >
          <div class="row">
              <p id="download">
            Descargar</p>
            <span v-if="loadingSave" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </div>
        </b-button>
        </div>
      </template>
    </b-modal>
     <!-- modal qr -->
    <h1 v-if="this.$route.params.id">Editar Vehículo</h1>
    <h1 v-if="!this.$route.params.id">Registrar Vehículo</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="createVehicle()" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Marca">
                <a-input
                  placeholder="Marca"
                  v-model="$v.getVehicleId.brand.$model"
                />
                <small class="text-danger" v-if="!$v.getVehicleId.brand.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Submarca">
                <a-input placeholder="Submarca" v-model="getVehicleId.subBrand" />
                <small class="text-danger" v-if="!$v.getVehicleId.subBrand.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Modelo">
                <a-input placeholder="Modelo" v-model="getVehicleId.model" />
                <small class="text-danger" v-if="!$v.getVehicleId.model.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Año">
                <v-select :options="years" v-model="$v.getVehicleId.year.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getVehicleId.year.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Placa">
                <a-input
                  placeholder="Número de Placa"
                  v-model="$v.getVehicleId.licensePlate.$model"
                />
                <small class="text-danger" v-if="!$v.getVehicleId.licensePlate.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!validateRegisteredPlate($v.getVehicleId.licensePlate.$model)">Ya existe un vehiculo registrado con esta placa</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Serie">
                <a-input placeholder="Número de Serie" v-model="$v.getVehicleId.serialNumber.$model" />
                <small class="text-danger" v-if="!$v.getVehicleId.serialNumber.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!validateRegisteredSerialNumber($v.getVehicleId.serialNumber.$model)">Ya existe un vehiculo registrado con este número de serie</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Tipo de vehículo">
                <v-select :options="Object.values(getVehicleType)" :reduce="type => type.id" v-model="$v.getVehicleId.vehicleType.id.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getVehicleId.vehicleType.id.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <!--
            <div class="col-md-6">
              <a-form-item label="Número de Serie Taxímetro">
                <v-select v-if="edicion"  :options="Object.values(getNotAssignedTaximetersPlus)" :reduce="taximeter => taximeter.id" v-model="$v.getVehicleId.taximeter.id.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <v-select v-if="!edicion" :options="Object.values(getNotAssignedTaximeters)" :reduce="taximeter => taximeter.id" v-model="$v.getVehicleId.taximeter.id.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getVehicleId.taximeter.id.required">Campo requerido</small>
              </a-form-item>
            </div>-->
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredPlate($v.getVehicleId.licensePlate.$model) && validateRegisteredSerialNumber($v.getVehicleId.serialNumber.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <div class="card" v-if="showConForm">
        <div class="card-body">
          <a-form :form="form2" @submit.prevent="addCon()" layout="vertical">
          <div class="row">
            <div class="col-md-12">
              <a-form-item label="Concesión">
                <v-select v-if="!primeraConcesion" :options="Object.values(getNotAssignedConcesionsPlus)" :reduce="concesion => concesion.label" v-model="addConcesion.concesionNumber"><span slot="no-options">Elemento no encontrado</span></v-select>
                <v-select v-if="primeraConcesion" :options="Object.values(getNotAssignedConcesions)" :reduce="concesion => concesion.label" v-model="addConcesion.concesionNumber"><span slot="no-options">Elemento no encontrado</span></v-select>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="disabledButton"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Asignar Concesión
                </button>
                <button @click="deleteConcesion" class="btn btn-light px-5 ml-3" type="button">
                  Desasignar Concesión
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
        </div>
      </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'
// import { encrypt } from '@/config/headers'
import QrcodeVue from 'qrcode.vue'
import config from '../../../../environment.json'
import headers from '@/config/headers.js'
const GET_VEHICLES_QUERY = gql`
  query getVehicles{
    getVehicles{
      id
      licensePlate
      serialNumber
    }
  }
`
export default {
  components: {
    QrcodeVue,
  },
  data: function () {
    return {
      edicion: false,
      primeraConcesion: false,
      teniaConcesion: false,
      error: null,
      disabledButton: false,
      showConForm: false,
      addConcesion: {
        concesionNumber: null,
      },
      optionsEco: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      optionsWoman: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      id: this.$route.params.id,
      form2: this.$form.createForm(this),
      form: this.$form.createForm(this),
      registeredPlate: {},
      registeredSerialNumber: {},
      getVehicleId: {
        brand: '',
        licensePlate: '',
        model: '',
        serialNumber: '',
        subBrand: '',
        year: null,
        vehicleType: {
          id: null,
          chargeDiscount: '',
          fare: '',
          type: '',
          active: 0,
        },
        /*
        taximeter: {
          id: null,
          serialNumber: '',
          status: 0,
        },  */
      },
      getVehicleType: {
        id: 0,
        type: '',
      },
      /*
      getNotAssignedTaximeters: {
        id: 0,
        serialNumber: '',
      },  */
      getNotAssignedConcesions: {
        id: 0,
        concesionNumber: '',
      },
      /*
      getNotAssignedTaximetersPlus: {
        id: 0,
        serialNumber: '',
      },  */
      getNotAssignedConcesionsPlus: {
        id: 0,
        concesionNumber: '',
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      showQrModal: false,
      qrValue: '',
      width: 200,
      loadingSave: false,
    }
  },
  apollo: {
    getVehicleId: {
      query: gql`
        query getVehicleId($id: Int!) {
          getVehicleId(id: $id) {
            brand
            licensePlate
            model
            serialNumber
            subBrand
            year
            vehicleType{
              id
              chargeDiscount
              fare
              type
              active
            }
          }
        }
      `,
      context: headers(),
      variables() {
        return {
          id: this.id || 0,
        }
      },
      result({ data }) {
        /*
        if (data.getVehicleId.taximeter === null) {
          this.getVehicleId.taximeter = {
            id: null,
            serialNumber: '',
            status: 0,
          }
        } */
        const plateEdition = data.getVehicleId.licensePlate
        const serialNumberEdition = data.getVehicleId.serialNumber
        this.$apollo.query({ query: GET_VEHICLES_QUERY, context: headers() })
          .then(({ data }) => {
            data.getVehicles.forEach(vehicle => {
              this.registeredPlate[vehicle.licensePlate] = 1
              this.registeredSerialNumber[vehicle.serialNumber] = 1
            })
            delete this.registeredPlate[plateEdition]
            delete this.registeredSerialNumber[serialNumberEdition]
            // console.log(this.registeredPlate)
            // console.log(this.registeredSerialNumber)
          })
          .catch(error => {
            console.log(error)
          })
        // console.log(data)
      },
      skip() {
        return this.skipQuery
      },
    },
    getConcesionsByVehicleId: {
      query: gql`
        query getConcesionsByVehicleId($vehicleId: Int!) {
          getConcesionsByVehicleId(vehicleId: $vehicleId) {
            id
            concesionNumber
          }
        }
      `,
      context: headers(),
      variables() {
        return {
          vehicleId: this.id || 0,
        }
      },
      skip() {
        return this.skipQuery
      },
      result ({ data, loading, networkStatus }) {
        if (data.getConcesionsByVehicleId) {
          if (this.getConcesionsByVehicleId != null) {
            this.teniaConcesion = true
            this.addConcesion.concesionNumber = this.getConcesionsByVehicleId.concesionNumber
            this.$apollo.queries.getNotAssignedConcesionsPlus.skip = false
            this.primeraConcesion = false
          } else {
            this.teniaConcesion = false
            this.$apollo.queries.getNotAssignedConcesionsPlus.skip = true
            this.primeraConcesion = true
          }
        } else {
          this.$apollo.queries.getNotAssignedConcesionsPlus.skip = true
          this.primeraConcesion = true
        }
      },
    },
    /*
    getNotAssignedTaximetersPlus: {
      query: gql`
        query getNotAssignedTaximetersPlus($vehicleId: Int!) {
          getNotAssignedTaximetersPlus(vehicleId: $vehicleId) {
            id
            label: serialNumber
          }
        }
      `,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      variables() {
        return {
          vehicleId: this.id || 0,
        }
      },
      skip() {
        return this.skipQuery
      },
      result ({ data, loading, networkStatus }) {
        this.getNotAssignedTaximetersPlus = data.getNotAssignedTaximetersPlus.filter(item => { return item != null })
        console.log('getNotAssignedTaximetersPlus')
        console.log(this.getNotAssignedTaximetersPlus)
      },
    },  */
    getNotAssignedConcesionsPlus: {
      query: gql`
        query getNotAssignedConcesionsPlus($vehicleId: Int!) {
          getNotAssignedConcesionsPlus(vehicleId: $vehicleId) {
            id
            label: concesionNumber
          }
        }
      `,
      context: headers(),
      variables() {
        return {
          vehicleId: this.id || 0,
        }
      },
      skip() {
        return this.skipQuery
      },
      result ({ data, loading, networkStatus }) {
        // console.log(data)
      },
    },
    getVehicleType: {
      query: gql`query getVehicleType{
      getVehicleType {
          id
          label: type
        }
      }`,
      context: headers(),
    },
    /*
    getNotAssignedTaximeters: {
      query: gql`query {
      getNotAssignedTaximeters {
          id
          label: serialNumber
        }
      }`,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
    },  */
    getNotAssignedConcesions: {
      query: gql`query getNotAssignedConcesions{
      getNotAssignedConcesions {
          id
          label: concesionNumber
        }
      }`,
      context: headers(),
    },
  },
  methods: {
    async addCon () {
      console.log(this.addConcesion.concesionNumber)
      console.log(this.id)
      if (this.addConcesion.concesionNumber == null) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }

      this.disabledButton = true
      await this.$apollo.mutate({
        mutation: gql`mutation updateVehicleConcesion($id: String, $vehicleId: Int) {
         updateVehicleConcesion(id:$id, vehicleId:$vehicleId){
          id
          vehicle{
            id
          }
        }
        }`,
        context: headers(),
        variables: {
          id: this.addConcesion.concesionNumber,
          vehicleId: parseInt(this.id),
        },
      })
        .then(res => {
          this.$router.push('/vehiculos/getVehicles')
        })
        .catch(error => {
          this.disabledButton = false
          this.error = error.message
          console.log(error)
        })
    },
    async deleteConcesion() {
      if (this.teniaConcesion === false) {
        this.mensaje.texto = 'El vehículo no tiene concesión asignada'
        this.mensaje.color = 'warning'
        this.showAlert()
        return
      }
      await this.$apollo.mutate({
        mutation: gql`mutation deleteConcesionByVehicleId($vehicleId: Int) {
         deleteConcesionByVehicleId(vehicleId:$vehicleId){
          message
        }
        }`,
        context: headers(),
        variables: {
          vehicleId: parseInt(this.id),
        },
      })
        .then(res => {
          this.$router.push('/vehiculos/getVehicles')
        })
        .catch(error => {
          this.disabledButton = false
          this.error = error.message
          console.log(error)
        })
    },
    async createVehicle() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      if (this.id != null) {
        // console.log(this.id)
        await this.$apollo.mutate({
          mutation: gql`mutation replaceVehicle($idEdit: Int, $brand: String, $licensePlate: String, $model: String, $serialNumber: String, $subBrand: String, $year: String, $vehicleTypeId: Int) {
         replaceVehicle(id: $idEdit, vehicle: {
          brand: $brand
          licensePlate: $licensePlate
          model:$model
          serialNumber: $serialNumber
          subBrand: $subBrand
          year: $year
          vehicleTypeId: $vehicleTypeId
        }){
          brand
          licensePlate
          model
          serialNumber
          subBrand
          year
          vehicleType{
            id
          }
        }
        }`,
          context: headers(),
          variables: {
            idEdit: parseInt(this.id),
            brand: this.getVehicleId.brand,
            licensePlate: this.getVehicleId.licensePlate,
            model: this.getVehicleId.model,
            serialNumber: this.getVehicleId.serialNumber,
            subBrand: this.getVehicleId.subBrand,
            year: this.getVehicleId.year.toString(),
            vehicleTypeId: parseInt(this.getVehicleId.vehicleType.id),
            // taximeterId: parseInt(this.getVehicleId.taximeter.id),
          },
        })
          .then(res => {
            this.$router.push('/vehiculos/getVehicles')
          })
          .catch(error => {
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
            console.log(error.message)
            this.disabledButton = false
          })
      } else {
        await this.$apollo.mutate({
          mutation: gql`mutation createVehicle($brand: String, $licensePlate: String, $model: String, $serialNumber: String, $subBrand: String, $year: String, $vehicleTypeId: Int) {
         createVehicle(vehicle: {
          brand: $brand
          licensePlate: $licensePlate
          model:$model
          serialNumber: $serialNumber
          subBrand: $subBrand
          year: $year
          vehicleTypeId: $vehicleTypeId
        }){
          brand
          licensePlate
          model
          serialNumber
          subBrand
          year
          vehicleType{
            id
          }
        }
        }`,
          context: headers(),
          variables: {
            brand: this.getVehicleId.brand,
            licensePlate: this.getVehicleId.licensePlate,
            model: this.getVehicleId.model,
            serialNumber: this.getVehicleId.serialNumber,
            subBrand: this.getVehicleId.subBrand,
            year: this.getVehicleId.year.toString(),
            vehicleTypeId: parseInt(this.getVehicleId.vehicleType.id),
            // taximeterId: parseInt(this.getVehicleId.taximeter.id),
          },
        })
          .then(res => {
            this.showQR(this.getVehicleId.licensePlate)
            // this.$router.push('/vehiculos/getVehicles')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    showQR(licensePlate) {
      this.showQrModal = true
      console.log(this.showQrModal.toString())
      this.qrValue = config[process.env.NODE_ENV].qrVehicle + licensePlate
      console.log(this.qrValue)
    },
    async saveImage() {
      this.loading = true
      const el = this.$refs.printMe
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
      }
      this.output = await this.$html2canvas(el, options)
      // console.log(this.output)
      this.saveAs(this.output, this.qrValue.replace(config[process.env.NODE_ENV].qrVehicle, '') + '.png')
    },
    saveAs(uri, filename) {
      var link = document.createElement('a')
      if (typeof link.download === 'string') {
        link.href = uri
        link.download = filename

        // Firefox requires the link to be in the body
        document.body.appendChild(link)

        // simulate click
        link.click()

        // remove the link when done
        document.body.removeChild(link)
        this.loading = false
      } else {
        window.open(uri)
      }
    },
    goListVehicles() {
      this.$router.push('/vehiculos/getVehicles')
    },
    validateRegisteredPlate(plate) {
      if (this.registeredPlate[plate.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredSerialNumber(serialNumber) {
      if (this.registeredSerialNumber[serialNumber.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.showConForm = true
      this.edicion = true
      // this.$apollo.queries.getNotAssignedTaximetersPlus.skip = false
      this.$apollo.queries.getConcesionsByVehicleId.skip = false
      this.$apollo.queries.getVehicleId.skip = false
    } else {
      this.$apollo.query({ query: GET_VEHICLES_QUERY, context: headers() })
        .then(({ data }) => {
          data.getVehicles.forEach(vehicle => {
            this.registeredPlate[vehicle.licensePlate] = 1
            this.registeredSerialNumber[vehicle.serialNumber] = 1
          })
          // console.log(this.registeredPlate)
          // console.log(this.registeredSerialNumber)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    // console.log(this.id)
    // this.$apollo.queries.getVehicleId.refetch()
  },
  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({ length: year + 1 - 2005 }, (value, index) => 2006 + index)
    },
  },
  validations: {
    getVehicleId: {
      brand: { required },
      model: { required },
      year: { required },
      subBrand: { required },
      licensePlate: { required },
      serialNumber: { required },
      vehicleType: {
        id: { required },
      },
      /*
      taximeter: {
        id: { required },
      },  */
    },
  },
}
</script>
<style>
.btn.btn-secondary, .show > .btn.btn-secondary {
    background-color: #ACADCB;
    border-color: #ACADCB;
}
.btn.btn-dark, .show > .btn.btn-dark {
    background-color: #042E41;
    border-color: #042E41;
}
.bg-dark {
    background-color: #ACADCB !important;
}

.modal .modal-header .close {
    background: #ACADCB;
}
.modal-title {
    color: #ffffff;
}
#download {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 0px;
}
#ready {
    margin-left: 35px;
    margin-right: 35px;
    margin-bottom: 0px;
}
.bg-light {
    background-color: #ffffff !important;
}
.btn.btn-outline-secondary, .show > .btn.btn-outline-secondary {
    border-color: #3B4DE6;
    color: #3B4DE6;
}
.btn.btn-outline-secondary:hover, .btn.btn-outline-secondary:active, .show > .btn.btn-outline-secondary:hover, .show > .btn.btn-outline-secondary:active {
    background-color: #3B4DE6 !important;
    border-color: #3B4DE6;
    color: #fff;
}
</style>
